export { default as DivisionsDataTable } from "./DivisionsDataTable";
export { default as DivisionsPage } from "./DivisionsPage";
export { default as BasicDivisionFields } from "./BasicDivisionFields";



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/divisions/index.js